import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import Section from '../components/Section';

export default () => (
  <Section id="procurement">
    <h1><FormattedHTMLMessage id="pages:procurement:title" /></h1>
    <FormattedHTMLMessage id="pages:procurement:description" />
  </Section>
);



// WEBPACK FOOTER //
// ./src/sections/Procurement.js